import React from 'react';
import i18next from 'i18next';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import MailsModuleListItem from './MailsModuleListItem';
import buttons from './MailsButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'mails/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'mails'),
			element: (
				<ViewPage
					module="mails"
					content={{ type: 'list', itemLayout: MailsModuleListItem }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
